import Button from '@mui/material/Button';
import SvgIcon from '@mui/material/SvgIcon';
import { QueryFilters, useQueryClient } from '@tanstack/react-query';
import { FC, useState } from 'react';
import RefreshIcon from 'src/assets/images/Refetch/RefreshIcon.svg';
import { setMinimalPromiseTime } from 'src/common/utils/setMinimalPromiseTime';

type LocationsRefreshProps = {
  'data-testid': string;
  disabled?: boolean;
  type?: QueryFilters['type'];
  predicate: QueryFilters['predicate'];
};

export const LocationsRefresh: FC<LocationsRefreshProps> = (props) => {
  const { disabled, predicate, type, 'data-testid': dataTestId } = props;
  const queryClient = useQueryClient();
  const [isRefreshing, setIsRefreshing] = useState(false);

  const refreshAll = () => {
    const refetchLocationsQueries = queryClient.refetchQueries({
      type,
      predicate,
    });

    setIsRefreshing(true);
    setMinimalPromiseTime(refetchLocationsQueries, 500).then(() => {
      setIsRefreshing(false);
    });
  };

  return (
    <Button
      data-testid={dataTestId}
      color="secondary"
      startIcon={
        <SvgIcon
          sx={{
            animation: isRefreshing ? `spin 1s linear infinite` : undefined,
          }}
        >
          <RefreshIcon />
        </SvgIcon>
      }
      onClick={refreshAll}
      disabled={disabled || isRefreshing}
      sx={{ boxShadow: 0 }}
    >
      Refresh
    </Button>
  );
};
